<template>
    <div class="chart-block">
        <h3>
               <a :href="url" target="_blank"> {{chartName}}</a>
            <el-tooltip class="item" effect="dark"   placement="bottom">
                <div v-html="tip" slot="content"></div> 
                <svg-icon name="faq" size="20" @click.native="faq()" color="#53b1e7"></svg-icon>
            </el-tooltip>
            <span>{{updated}}</span>
      

            <el-radio-group v-model="marketType" size="mini" class="opt"   @change="bindChart()" :disable="loading" >
                <el-radio-button label="新四化整体"></el-radio-button>
                <el-radio-button label="电动化"></el-radio-button>
                <el-radio-button label="网联化"></el-radio-button>
                <el-radio-button label="智能化"></el-radio-button>
            </el-radio-group>
        </h3>
        <div id="chart_cmnc" class="chart-box" v-loading="loading"></div>
    </div>
</template>
<script>
    import echarts from "echarts";
     import {strToYeayAndMonth } from '@/plugins/DateTimeFormater.js';
    import {
        mapMutations,
        mapGetters,
        mapActions,
        mapState
    } from "vuex";
    export default {
        props: {
            chartName: {
                type: String,
                default: "新四化新车上市月度数量统计"
            }
        },
        data() {
            return {
                url:"#",
                loading:true,
                tip:'分上市类型的新四化车款数量月度统计',
                chartOption: {},
                updated: "",
                dataDate:'',
                marketType: "新四化整体" ,
                chartId:'current_month_count',
                      };
        },
        mounted() {
             let      icon='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAAAwCAYAAAC/gkysAAABhElEQVRoge3avS6EQRTG8eMjIjQ6FKJ3A25CJxqVWq3aZWYawg3odKpzdsNGQjYhW+hUCnELzHlthA2FZhQSH8mbiFdi9sRzkn//zK8eok8XDu4nvOimF2171hsvmv51rDdO9DiIrgfWKSq7IMWCk3iXfWwfF1hXvqKxruQeZSXXiItERFRrxUnH+pJ7kJk4dtfat+PkRLezjzFWkLhGjvUy9xBrOdYLcqKPuYdYjHIPsBrgAAc4EwEOcIAzEeAABzgTAQ5wgDMR4AAHOBMBDnCAMxHgAAc4EwEOcIAzEXnWXu4RFiMn8Sr3CGs51mtyolu5h9ir2KFas5jOP8RS8al+2J3Bj8wf9v4j8+MPcFzNPaqfcxyfAxfL5R+ouTvnuNj1rA+5h/ZNrD3PsVVv3s+WouU6L7r324dtNO7mc7/j7y+lASdxH2gVLqQ06FkFaBVuidOQ59gCWoULnTT8LR7Qyu8NT0+AVuECpxHP8QxoFS500qhnPQdahQtHacxJPO1HtFerNkp+/CyOOAAAAABJRU5ErkJggg==';
  
            this.chartOption = {
                   tooltip: {
                    formatter:function(params,ticket, callback){
                        return '类型:'+params.name+'<br />上市：'+params.value+' 款'
                    }
                },
                title: {
                    text: "单位：辆",
                    show: false,
                    right: "5%",
                    top: "30%",
                    textStyle: {
                        fontWeight: 'normal',
                        color: '#6a7e97'
                    },
                },
                legend: {
                    orient: 'vertical',
                    right: "5%",
                    top: "46%",
                    show:false
                },
                grid: {
                    left: "5%",
                    right: "3%",
                    bottom: "3%",
                    containLabel: true
                },
                xAxis: {
                    type: "category",
                  
                    data: [
                        "新车",
                        "换代",
                        "改款",
                        "年度",
                        "新增",
                        // "价格调整"
                    ],
                    axisLabel: {
                        //坐标轴刻度标签的相关设置。
                        interval: 0, //设置为 1，表示『隔一个标签显示一个标签』
                        //	margin:15,
                        textStyle: {
                            color: "#1B253A",
                            fontStyle: "normal",
                            fontFamily: "微软雅黑",
                            fontSize: 12
                        },
                       //  rotate:50,
                    },
                    axisTick: {
                        //坐标轴刻度相关设置。
                        show: false
                    },
                    axisLine: {
                        //坐标轴轴线相关设置
                        lineStyle: {
                            color: "#E5E9ED"
                            // opacity:0.2
                        }
                    },
                    splitLine: {
                        //坐标轴在 grid 区域中的分隔线。
                        show: false,
                        lineStyle: {
                            color: "#E5E9ED"
                            // 	opacity:0.1
                        }
                    }
                },
                yAxis: {
                    type: "value",
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    }
                },
                series: {
                        name: "MPV",
                        type: 'pictorialBar',
                         barGap : '100%',
             
                        // barWidth:'33px',
                       symbol: 'path://M72.43,111.16C57.08,111.16,48.42,0,36.22,0S15.35,111.16,0,111.16;',
  //  symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
                               label: {
              normal: {
                show: true,
                position: 'top',
                //字体颜色
                color: '#FFFFFF',
                backgroundColor:{
                  image: icon,
              
                },
                 
                /*borderRadius:12,*/
                padding:[5,12,5,12],
              },
              
            },
                                      
                         itemStyle: {
                            normal: {
                                color: "rgba(127,171,234,1)",
                            }
                        },
                        data: [0, 0, 0, 0, 0, 0]
                    }
                    // ,
                    // {
                    //     name: "SUV",
                    //     type: 'pictorialBar',
                    //        barGap : '-60%',
                    //      barWidth:'33px',
                    //      symbol: 'path://M72.43,111.16C57.08,111.16,48.42,0,36.22,0S15.35,111.16,0,111.16',
                    //     itemStyle: {
                    //         normal: {
                    //             color: "rgba(175,200,243,0.9)",
                    //         }
                    //     },
                    //     data: [41, 66, 42, 31, 15, 22]
                    // },
                    // {
                    //     name: "Sedan",
                    //     type: 'pictorialBar',
                    //      barGap : '-30%',
                    //     barWidth:'33px',
                    //     symbol: 'path://M72.43,111.16C57.08,111.16,48.42,0,36.22,0S15.35,111.16,0,111.16',
                    //    itemStyle: {
                    //         normal: {
                    //             color: "rgba(126,145,201,0.9)",
                    //         }
                    //     },
                    //     data: [0, 46, 72, 11, 41, 35]
                    // }
                
            };

            this.getChartList({
                handle: this.updateChart
            });
        },
          methods: {
            ...mapActions("home", ["queryChartConfigs", "queryChartUpdate", "getChartList","queryChartBuild"]),
           
            updateChart() {
                var self = this;
                this.myChart = echarts.init(document.getElementById('chart_cmnc'));
                this.myChart.setOption(this.chartOption);

               
                window.addEventListener('resize', () => {
                    this.myChart.resize()
                });
         
           var info = this.getChartByName(this.chartId);
          this.url = info.url;
          if(info.updateOption==2){
                this.jsonData =   eval(info.jsonData) ;              
                 this.dataDate = info.lastUpdated;
                this.bindChart();
           }else if(info.updateOption==1){
             var self = this;
             var postData = {'chartName':this.chartId,'noCache':false};
             this.queryChartBuild({params:postData,handle:function(res){
               self.jsonData = res.data;
               self.dataDate = res.updated;
               self.bindChart();
             }});

           }
                if(this.myChart._$handlers.click)
                {
                    this.myChart._$handlers.click.length = 0;
                }
             this.myChart.on('click',function(params){
                 console.log(params);
                // alert(JSON.stringify(params));
             });
            },
            bindChart() {
                           
                this.updated = `最新数据时间 ${strToYeayAndMonth(this.dataDate)} `;
               // this.chartOption.xAxis.data = [];
                this.chartOption.series.data = [];

                var x = this.jsonData.filter(x => x.t == this.marketType);

                var dict = { "新车":0,
                        "换代":0,
                        "改款":0,
                        "年度":0,
                        "新增":0,
                        "价格调整":0};
             
                      

                for (var item of x) {
                     if(item.name=="NP")
                     {
                         dict["新车"] +=item.value;
                     }else if(item.name=="GP")
                     {
                         dict["换代"] +=item.value;
                     }else if(item.name=="NM")
                     {
                         dict["新增"] +=item.value;
                     }else if(item.name=="MSRP")
                     {
                         dict["价格调整"] +=item.value;
                     }
                     else if(item.name=="MCE1")
                     {
                         dict["年度"] +=item.value;
                     }
                     else if(item.name.indexOf('MCE')>-1)
                     {
                         dict["改款"] +=item.value;
                     }
                     
                   
                }
                 for(let item in  dict){
                                this.chartOption.series.data.push(dict[item]);
                 }
              
                this.myChart.setOption(this.chartOption);
                this.loading = false;
            }
        },
        computed: {
            ...mapGetters("home", {
                chartList: "chartList",
                getChartByName: "getChartByName"
            }),
        },
        watch: {},
        created() {}
    };
</script>
 